export default {
  userGroup: null,
};
